import React, { useEffect, useRef, useState } from "react";
import "../styles/WeekdayScheduler.css";
import { TimePicker, Space, Row, Col, Popover, Badge } from "antd";
import {
  CloseCircleFilled,
  ClockCircleOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import BrightnessSchedulerEditor from "./BrightnessSchedulerEditor";
import moment from "moment";
const { RangePicker } = TimePicker;
const weekdays = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];
const weekdayNums = [1, 2, 3, 4, 5, 6, 0];

function BrightnessSchedulerItem(props) {
  const [schData, setSchData] = useState(null);
  const [displayTimes, setDisplayTimes] = useState("No Specific Time");
  const [displayDates, setDisplayDates] = useState("No Specific Dates");
  const [editorVisible, setEditorVisible] = useState(false);
  const { onRemove = () => {}, data, onSaved = () => {} } = props;
  const editorRef = useRef();
  const inputDateformat = "YYYY-MM-DD";
  const dateFormat = "DD-MM-YYYY";
  const inputformat = "HH:mm:ss";
  const format = "HH:mm";

  useEffect(() => {
    if (props.data) {
      setSchData(props.data);
    }
  }, []);

  useEffect(() => {
    if (!schData) return;
    var time = `${new moment(schData.StartTime, inputformat).format(format)} - ${new moment(schData.EndTime, inputformat).format(format)}`;
    // var days = `${schData.StartDate} - ${schData.EndDate}`
    var days = `${new moment(schData.StartDate, inputDateformat).format(dateFormat)} - ${new moment(schData.EndDate, inputDateformat).format(dateFormat)}`;

    if (
      (schData.StartTime === "00:00:00" && schData.EndTime === "23:59:59") ||
      (schData.StartTime === "" && schData.EndTime === "")
    ) {
      time = "No Specific Time";
    }
    if (schData.StartDate === "" && schData.EndDate === "") {
      days = "No Specific Dates";
    }

    setDisplayTimes(time);
    setDisplayDates(days);
  }, [schData]);

  const handleVisibleChanged = (visible) => {
    setEditorVisible(visible);
    if (!visible) {
      if (editorRef.current) {
        editorRef.current.resetUnsavedChanged();
      }
    }
  };

  const onWeekdayScheduleSaved = (newData) => {
    setSchData(newData);
    setEditorVisible(false);
    onSaved();
  };

  if (!schData) {
    return null;
  }
  return (
    <Popover
      onOpenChange={handleVisibleChanged}
      placement="bottom"
      trigger="click"
      open={editorVisible}
      content={
        <BrightnessSchedulerEditor
          ref={editorRef}
          data={schData}
          onSave={onWeekdayScheduleSaved}
        ></BrightnessSchedulerEditor>
      }
    >
      <div className="itemrow" style={{ position: "relative" }}>
        <Badge.Ribbon
          color="#f8c55f"
          text={
            <div style={{ color: "#444" }}>
              <img
                src="/cms/assets/svgs/icons/brightness_100_icon.svg"
                style={{ width: "15px", height: "15px", margin: "0 5px" }}
              />
              {`${schData.Brightness}%`}
            </div>
          }
        >
          <div className="scheduletext scheduler">
            <div className="schedulerow">
              <div className="labelgroup" style={{ flex: 1 }}>
                {weekdays.map((day, index) => {
                  const isActive =
                    schData.WeekDay.indexOf(`${weekdayNums[index]}`) !== -1;
                  const style = isActive
                    ? "ui mini active label"
                    : "ui mini label";
                  return <div className={style}> {day.charAt(0)}</div>;
                })}
              </div>
            </div>

            <div>
              <Row
                gutter={16}
                justify="space-between"
                style={{ padding: "0 10px", fontSize: "12px" }}
              >
                <Col>
                  <Space align="start">
                    <ClockCircleOutlined />
                    {displayTimes}
                  </Space>
                </Col>
                <Col>
                  <Space align="end">
                    <CalendarOutlined />
                    {displayDates}
                  </Space>
                </Col>
              </Row>
            </div>
          </div>
        </Badge.Ribbon>
        <div
          onClick={(e) => {
            onRemove(e);
            e.preventDefault();
          }}
          className="btn-remove-item"
          style={{ position: "absolute", right: "-24px", top: 0 }}
        >
          <CloseCircleFilled
            style={{
              color: "rgb(221, 221, 221)",
              cursor: "pointer",
              fontSize: "20px",
            }}
          />
        </div>
      </div>
    </Popover>
  );
}

export default BrightnessSchedulerItem;
